import navbarStore from '@/store/navbar';
import globalStore from '@/store/global';
import localRobot from '@/common/localRobot.js';
import EE from '@/common/event'
import { SVGPureIcon } from '@/ui';

const CreateBtn = ({ className, title = '新建对话', onClick, scene="" }) => {
  if (navbarStore.isCollapse) {
    return null;
  }
  return (
    <div
      onClick={() => {
        EE.emit('chat_input_focus');
        if(scene == "aigent") {
          globalStore.navigate(`/tools/aiagent`);
          return
        }
        if (scene == "aimodel") {
          globalStore.navigate(`/teamhome`);
          return
        }
        if (onClick) {
          onClick();
        }else {
          localRobot.destory();
          globalStore.gotoHome();
        }
      }}
      style={{
        boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.20)'
      }}
      className={[
        'w-128px h-40px flex items-center flex-shrink-0',
        (scene == "aigent" || scene == "aimodel") ? "w-166px" : "",
        globalStore.isDark ? 'bg-gray-nav' : '',
        'text-primary border-1px border-solid rounded-8px cursor-pointer boder-[rgba(0,0,0,0.1)] border-opacity-10 hover:bg-[rgba(0,0,0,0.03)]',
        className,
      ]}
    >
    <SVGPureIcon name="ic-add" className="size-24px ml-8px mr-4px" />
    <div className="text-14px font-bold text-black">{title}</div>
  </div>
  );
};

export default CreateBtn;
